<template>
    <div class="tabletBody">
        <div class="container">
            <div class="row">
                <div class="worker_wrap">
                    <div class="header_line">
                        ҚЫЗМЕТ КӨРСЕТУ АҒА КЕҢЕСШІСІ<br>
                        КОНСУЛЬТАНТ ПО СЕРВИСУ
                    </div>

                    <div class="worker_name">
                        {{ user_surname }}<br>
                        {{ user_name }}
                    </div>
                    <div class="company_address">
                        <strong>Тойота Центр Костанай</strong><br>
                        ТОО «Тобол Моторс»<br>
                        110000, г.Костанай, пр.Абая 26«в»<br>
                        (7142) 26 81 81<br>
                        (7142) 39 44 44<br>
                        www.toyota-kostanay.kz
                    </div>
                </div>
                <div class="worker_photo">
                    <img :src="user_photo" :alt="user_surname">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "workerPage",
        data: function() {
            return {}
        },
        props: {
            user_surname: {
                default() {
                    return {}
                }
            },
            user_name: {
                default() {
                    return {}
                }
            },
            user_photo: {
                default () {
                    return {}
                }
            }
        },
        computed: {}
    }
</script>
